// The printing_machine SETTINGS config the /mcc page seeds on window (frank/edit.html.erb rendered it from
// QUOTE_BUILDER_CONFIG_SETTINGS, because the page itself is handed the SECTIONS config), and the
// UserUnitPriceAttribute tab within it -- the machine-manager list (SettingsUserUnitPriceAttributeList) is driven
// by that tab. Shared by the filter-island "Manage" button and the guided-setup wizard's add-machine stage.
export const printingMachineConfig = () => window.frank_printing_machine_settings_config || {};

export const printingMachineTabConfig = () => (
  (printingMachineConfig().tabs || []).find((tab) => tab.form_type === 'UserUnitPriceAttribute')
);
